import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["prefixCls", "className", "style", "color", "max", "dot", "processing", "count", "children"];
import React from 'react';
import "./style/index.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
      prefixCls = 'w-badge',
      className,
      style = {},
      color,
      max = 99,
      dot = false,
      processing = false,
      count,
      children
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  var supProps = {
    className: [!dot ? prefixCls + "-count" : null, dot ? 'dot' : null].filter(Boolean).join(' ').trim(),
    style: {}
  };
  var cls = [className, prefixCls, !children ? 'nowrap' : null, !children ? prefixCls + "-status" : null, processing ? prefixCls + "-processing" : null].filter(Boolean).join(' ').trim();
  var warpperProps = {};
  if (count || count === 0) {
    supProps.style = _extends({
      backgroundColor: color
    }, style);
  } else {
    warpperProps.style = style || {};
  }
  return /*#__PURE__*/_jsxs("span", _extends({
    className: cls
  }, other, warpperProps, {
    ref: ref,
    children: [color && /*#__PURE__*/_jsx("span", {
      className: prefixCls + "-dot",
      style: {
        backgroundColor: color
      }
    }), children, count !== 0 && !color && /*#__PURE__*/_jsx("sup", _extends({}, supProps, {
      children: !dot && count && max && count > max ? max + "+" : count
    }))]
  }));
});